import "../../i18n";
import { useTranslation } from "react-i18next";
import "./CareersPage.scss"; // import CSS file
import SingleLayerIntroSection from "../../Components/Text/ParallaxTitle/Simple/SimpleParallaxTitle";
import Map from "../../Components/Maps/map";
import "../../i18n";
import { Team } from "../../Data/Constants";
import { CareersPageData } from "../../Data/Translation/CareersPage/Data_CareersPage";
import { useState } from "react";
import { JobOpening } from "../../Models/JobOpening";

export default function Careers() {
  const { t, i18n } = useTranslation();
  const [openCardId, setOpenCardId] = useState<number | null>(null);

  // Fetch the jobs array directly from our i18n translation file
  const jobsList: JobOpening[] = t("careers.jobs.openings", {
    returnObjects: true,
  });

  const handleContactClick = (jobTitle: string) => {
    window.location.href = `mailto:talent@simdev.ca?subject=Application pour ${jobTitle}`;
  };

  const toggleCard = (id: number) => {
    setOpenCardId((prevId) => (prevId === id ? null : id));
  };
  const currentPageData =
    i18n.language === "fr"
      ? CareersPageData.CareersPageData_fr
      : CareersPageData.CareersPageData_en;

  return (
    <div>
      <SingleLayerIntroSection
        title={t("careers.title.text")}
        backgroundImage={Team.picture}
        subtitle=""
        textBackground={{
          enabled: true,
          color: "red",
          rounded: true,
          opacity: 0.5,
        }}
      />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 text-center mb-5 mt-5">
            <h1
              className="mb-4 display-3"
              style={{ color: "var(--main-color-dark)" }}
            >
              {t("careers.description.title")}
            </h1>
            <div className="lead text-muted" style={{ textAlign: "justify" }}>
              {currentPageData.description.text.map((desc, index) => (
                <p key={index} className="mb-3">
                  {desc}
                </p>
              ))}
            </div>
          </div>
        </div>
        <div className="jobs-section">
          <h2 className="jobs-section-title">{t("careers.jobs.title")}</h2>

          <div className="jobs-grid">
            {/* We map directly over the translated jobsList array */}
            {jobsList.map((job) => {
              const isOpen = openCardId === job.id;

              return (
                <div
                  key={job.id}
                  className={`job-card ${isOpen ? "open" : ""}`}
                >
                  {/* Header */}
                  <div
                    className="job-card-header"
                    onClick={() => toggleCard(job.id)}
                  >
                    <h3 className="job-title">{job.title}</h3>
                    <svg
                      className={`chevron-icon ${isOpen ? "rotated" : ""}`}
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </div>

                  {/* Body */}
                  <div className="job-card-body-wrapper">
                    <div className="job-card-body-inner">
                      <div className="job-card-content">
                        <p className="job-intro-text">{job.description}</p>

                        {/* FIXED: Responsibilities Label */}
                        <div className="job-details-group">
                          <h4 className="job-details-title">
                            {t("careers.jobs.labels.responsibilities")}
                          </h4>
                          <ul className="job-list">
                            {job.responsibilities.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </div>

                        {/* FIXED: Profile Label */}
                        <div className="job-details-group">
                          <h4 className="job-details-title">
                            {t("careers.jobs.labels.profile")}
                          </h4>
                          <ul className="job-list">
                            {job.profile.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </div>

                        {/* FIXED: Conditions Label */}
                        <div className="job-details-group">
                          <h4 className="job-details-title">
                            {t("careers.jobs.labels.conditions")}
                          </h4>
                          <ul className="job-list">
                            {job.conditions.map((item, index) => (
                              <li key={index}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <button
                          className="apply-career-button"
                          onClick={() => handleContactClick(job.title)}
                        >
                          {/* FIXED: Apply Button Label */}
                          {t("careers.jobs.apply_button")}
                        </button>
                      </div>
                      <div style={{ textAlign: "center", marginTop: "2rem" }}>
                        <button
                          className="apply-career-button"
                          onClick={() => handleContactClick(job.title)}
                        >
                          {t("availableJobs.apply_button")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {/* --- MAP SECTION --- */}
      {/* We use a subtle gray background to separate the map from the jobs visually */}
      <div className="container-fluid py-5 bg-light border-top">
        <div className="container my-4">
          <div className="row align-items-center">
            {/* Map Text - Left Side */}
            {/* col-lg-5: Takes up 5/12 columns on desktop. mb-5 mb-lg-0: Adds margin bottom on mobile, removes it on desktop */}
            <div className="col-lg-5 mb-5 mb-lg-0">
              <h2
                className="display-5 fw-bold mb-3"
                style={{
                  color: "var(--main-color-dark)",
                  letterSpacing: "-1px",
                }}
              >
                {t("location.title")}
              </h2>
              <h5 className="fs-4 text-muted mb-4 pb-2 border-bottom">
                {t("location.address")}
              </h5>

              <div className="fs-5" style={{ color: "var(--main-color-dark)" }}>
                <div className="mb-2">
                  <strong style={{ color: "var(--secondary-color-lightblue)" }}>
                    T:
                  </strong>{" "}
                  (514) 686-6868
                </div>
                <div>
                  <strong style={{ color: "var(--secondary-color-lightblue)" }}>
                    E:
                  </strong>{" "}
                  <a
                    href="mailto:info@simdev.ca"
                    style={{
                      color: "var(--main-color-dark)",
                      textDecoration: "none",
                    }}
                    className="hover-link"
                  >
                    info@simdev.ca
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="custom-map-wrapper">
                <Map />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
